<div fxLayout="column" class="neq-dialog">
  <p>
    <span>{{'msg.common.error.text1' | translate}}</span><br>
    {{'msg.common.error.text2' | translate}}<br>
    {{'msg.common.error.text3' | translate}}<br>
  </p>

  <ng-container *ngIf="detail">

    <div *ngIf="message" [innerHTML]="message"></div>
    <p>
      <textarea style="width: 90%;" rows="4" [value]="detail" #errordetail></textarea>
    </p>
    <button mat-button
            (click)="copyInputMessage(errordetail)">{{'msg.common.error.copy-to-clipboard' | translate}}</button>
  </ng-container>
  <ng-container *ngIf="!detail">
    <div *ngIf="message" [innerHTML]="message"></div>
  </ng-container>

  <div class="asi-container" fxLayout="row" fxLayoutAlign="center center">
    <button pButton class="neq-primeng-button-text" label="{{'msg.common.validation.ok' | translate}}" (click)="continue()"></button>
  </div>

  <div fxLayout="row">
    <div fxLayout="column" fxLayoutAlign="center">V{{appVersion}}</div>
  </div>

</div>
